module.exports = __webpack_public_path__ + "img/search.55473c27.svg";